@if (!loading) {
  <div class="background-gradient">
    <div class="left-rect"></div>
    <div class="right-rect"></div>
  </div>
}
@if (!loading && brandingUpdated) {
  <div class="nf-icon-container"><div class="nf-icon"></div></div>
}
@if (!loading) {
  <div class="private-key-page">
    <div class="private-key-form">
      @if (!isSuccessful) {
        <div>
          <div class="private-key-header">
            <div class="private-key-icon"></div>
            <div class="private-key-title-container">
              <div class="private-key-form-title">
                Add your private key below
              </div>
              <div class="private-key-form-subtitle">
                Use the field below to copy and paste your SSH key
              </div>
            </div>
          </div>
          <div class="private-key-form-content">
            <textarea
              [(ngModel)]="value"
              id="NewStoredSecretValue"
              (change)="validate()"
              [ngClass]="{'ng-invalid': !isValid}"
              placeholder="Paste your key here."
            ></textarea>
            <span [hidden]="!errors['value']" class="err">
              {{ errors['value'] }}
            </span>
            <span [hidden]="!errors['token']" class="err">
              {{ errors['token'] }}
            </span>
          </div>
          <div class="private-key-form-buttons">
            <button (click)="submitStoredSecret()" class="save confirm" label="Save" >Add Key</button>
          </div>
        </div>
      }
      @if (isSuccessful) {
        <div class="private-key-header-success">
          <div class="private-key-title-container">
            <div style="text-align: center;" class="private-key-form-title">
              Update Successful
            </div>
            <div class="private-key-form-subtitle">
              Your private key was updated successfully
            </div>
            <div style="text-align: center; padding-top: 0.9375rem;">
              <span class="pi pi-check-circle" style="font-size: 2.0rem; color: #00db48; align: center;"></span>
            </div>
            <div class="private-key-form-content">
              You may now close the window.
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
@if (loading) {
  <app-loading-indicator [isLoading]="loading" ></app-loading-indicator>
}
